<template>
  <div class="list-content">
    <div :ref="refName" class="list-table-block">
      <el-table :empty-text="$t('label_357')" class="black-table" :height="height" :data="tableData" border style="width: 100%;height: 100%;"
        highlight-current-row @current-change="handleCurrentChange" @selection-change="change">
		<template v-if="checkBox">
		     <el-table-column
		      type="selection"
		     width="55">
		    </el-table-column>
		    </template>
        <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="100">
        </el-table-column>
        <el-table-column :header-align="item.headerAlign" :align="item.align" :prop="item.column" :label="item.title"
          :style="{'width':item.width}" v-for="(item,index) in tableList" :key="index">
          <template slot-scope="scope">
            <template v-if="item.termList">
              <template v-for="(items,index) in item.termList">
<!-- 				 ({{items.id}}/
				  {{scope.row[item.column]}}) -->
                <template v-if="items.id === scope.row[item.column]">
                  <template v-if="items.color !== undefined && items.color !== ''">
                    <span :style="{color:items.color}">{{item.termList[index].name}}</span>
                  </template>
                  <template v-else>
                    {{item.termList[index].name}}
                  </template>
                </template>
              </template>
            </template>
            <template v-else>
              {{scope.row[item.column]}}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'list',
    props: {
      refName: {
        type: String,
        default: 'refList'
      },
      tableData: {
        type: Array,
        default: []
      },
      tableList: {
        type: Array,
        default: []
      },
      pageSize: {
        type: Number,
        default: 0
      },
      pageNo: {
        type: Number,
        default: 0
      },
	  checkBox: {
	    type: Boolean,
	    default: false
	  },
    },
    data: function() {
      return {
        height: 0,
      }
    },
    methods: {
      getIndex(index) {
        // console.log("pageNo:" + JSON.stringify(this.pageNo));
        // console.log("pageSize:" + this.pageSize);
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleCurrentChange(val) {
        this.$emit('parentMethod', val);
      },
      getHeight() {
        this.height = this.$refs[this.refName].clientHeight - 5;
      },
	  change(val){
	      this.$emit('checkMethod', val);
	     }
    },
    mounted() {
      this.timer = setTimeout(() => {
        this.height = this.$refs[this.refName].clientHeight - 5;
      }, 200);
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/list2.vue